export const RETRY_ATTEMPTS_LIMIT = 1;
